<template>
  <div id="app">
    <div class="menu-box" v-if="screenWidth > 750">
      <div class="log-box">
        <!-- <img src="@/assets/logo.png" alt=""> -->
        <span>Rupee Wave</span>
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'choice' : ''">Home</div>
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">About Us</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">Advantages</div>
        <div @click="choiceMenu(3)" :class="(menuIndex === 3) ? 'choice' : ''">Business scope</div>
        <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'choice' : ''">Questions & Contacts</div>
      </div>
    </div>
    <div id='step_1' ref="step_1" class="ref-home"></div>
    <div class="banner-box" id='home' ref="home">
      <img src="../assets/banner.png" class="banner">
    </div>

    <div id='step_2' ref="step_2"></div>
    <div class="about-us-box">
      <img src="../assets/img-1.png" class="img-box">
      <div class="about-text">
        <div class="title">About Us</div>
        <div class="line"></div>
        <div class="text-box">
          Kiara Microcredit Private Limited is a dynamic and forward-thinking financial institution committed to empowering individuals and small businesses. With a focus on financial inclusion, we provide accessible and tailored microcredit solutions to help our clients achieve their financial goals.
        </div>
      </div>
    </div>

    <div id='step_3' ref="step_3"></div>
    <div class="applicable-box">
      <div class="title">Advantages</div>
      <div class="line"></div>
      <div class="img-box">
        <div class="year-box">
          <img src="../assets/icon-1.png" alt="">
          <p>1.Provide high-quality, innovative financial products and services that help individuals and small businesses achieve their dreams and goals.</p>
        </div>
        <div class="year-box">
          <img src="../assets/icon-2.png" alt="">
          <p>2.Composed of an experienced professional team committed to meeting customer needs and delivering exceptional value.</p>
        </div>
        <div class="year-box">
          <img src="../assets/icon-3.png" alt="">
          <p>3.Emphasize transparency and accountability to ensure customers receive high-quality services and products.</p>
        </div>
        <div class="year-box">
          <img src="../assets/icon-4.png" alt="">
          <p>4.Assume corporate social responsibility and invest in social development projects focused on education, healthcare, and poverty reduction to actively impact the communities it serves.</p>
        </div>
      </div>
    </div>

    <div id='step_4' ref="step_4"></div>
    <div class="hear-box">
      <div class="title">What can we do?</div>
      <div class="line"></div>
      <div class="juan-esteban">
        <swiper :options="pagination">
          <swiper-slide>
            <div class="swiper-1">
              <div class="swiper-title">Rajesh Kumar</div>
              <div class="img-box">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
              </div>
              <div class="swiper-text">Kiara Microcredit Private Limited is committed to corporate social responsibility and sustainability. The company invests a portion of its profits in social development projects that focus on education, healthcare, and poverty reduction. Through its efforts, Kiara Microcredit Private Limited strives to make a positive impact on the communities it serves.</div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-2">
              <div class="swiper-title">Priya Patel</div>
              <div class="img-box">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
              </div>
              <div class="swiper-text">We take pride in our customer-centric approach, offering personalized financial solutions, flexible repayment options, and a seamless application process. Our dedicated team of professionals works diligently to ensure that our clients receive the support they need to grow their businesses, invest in their education, and secure a brighter future.</div>

            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-3">
              <div class="swiper-title">Aman Sharma</div>
              <div class="img-box">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
              </div>
              <div class="swiper-text">Through itsMicrocredit services, Kiara Microcredit Private Limited provides access to capital that enables individuals and small businesses to pursue their dreams and goals. In addition to loans, the company also provides investment consulting, loan consulting and other related financial services.These offerings are designed to meet the diverse needs of its customers and help them build a brighter future.</div>

            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>

    <div id='step_5' ref="step_5"></div>
    <div class="foot-box">
      <div class="title">Questions & Contacts</div>
      <div class="foot-text">
        <p> If you experience any issues with us, please contact our customer service team for assistance.</p>
        <p> Customer service hours: Monday to Friday 08:00 - 17:00</p>
        <p> Email: shantejohnsonnew@gmail.com</p>
        <p> Address:GGG4+XQ7, Pahadi, Madhya Pradesh 480887</p>
      </div>
      <div class="copyright">Copyright 2023. All rig hts reserved.</div>
    </div>

  </div>
</template>

<script>
import privacy from "@/components/privacy";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'
export default {
  name: 'App',
  components: {
    privacy,
    Swiper,
    SwiperSlide,
    directive
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      pagination: {
        autoplay: true,
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          // disabledClass: 'my-button-disabled',
        },
      }
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    let item = this.$route.query.item
    console.log(item);
    if (item == 'partners') {
      this.$nextTick(() => {
        setTimeout(() => {
          this.choiceMenu(4)
        }, 1000);
      })
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("step_1").scrollIntoView(); break;
        case 1: document.getElementById("step_2").scrollIntoView(); break;
        case 2: document.getElementById("step_3").scrollIntoView(); break;
        case 3: document.getElementById("step_4").scrollIntoView(); break;
        case 4: document.getElementById("step_5").scrollIntoView(); break;
        case 5: document.getElementById("step_6").scrollIntoView(); break;
        case 6: document.getElementById("step_7").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    },
    gotoPrivacy() {
      this.$router.push({
        path: "/Privacy",
      });
    }
  }
}
</script>


<style lang="less" >
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
